import type { IdentifiedProviderDefinition } from "@/src/models/provider-definition";

/** Names and titles follow the existing provider rules; display labels and identifiers stay unchanged. */
export const NIMBUS_PROVIDERS = {
  DEAN: {
    displayName: "J. Dean",
    name: { givenName: "Jon", familyName: "Dean", honorific: "Dr." },
    npi: "1609859859",
    ehrId: "19",
  },
  ROBINSON: {
    displayName: "D. Robinson",
    name: { givenName: "Donald", familyName: "Robinson", honorific: "Dr." },
    npi: "1235271636",
    ehrId: "15",
  },
  HENDRICKS: {
    displayName: "M. Hendricks",
    name: { givenName: "Mark", familyName: "Hendricks", honorific: "Dr." },
    npi: "1306827639",
    ehrId: "18",
  },
  PRITCHETT: {
    displayName: "K. Pritchett",
    name: { givenName: "Kimberly", familyName: "Pritchett" },
    npi: "1881124071",
    ehrId: "17",
  },
  FOREHAND: {
    displayName: "B. Forehand",
    name: { givenName: "Brett", familyName: "Forehand" },
    npi: "1427430180",
    ehrId: "14",
  },
  ROBBINS: {
    displayName: "A. Robbins",
    name: { givenName: "Alison", familyName: "Robbins", otherNames: ["Ali Robbins"] },
    npi: "1164862710",
    ehrId: "13",
  },
  COWART: {
    displayName: "K. Cowart",
    name: { givenName: "Kaleigh", familyName: "Cowart" },
    npi: "1598273377",
    ehrId: "16",
  },
  RUNDBAKEN: {
    displayName: "C. Rundbaken",
    name: { givenName: "Craig", familyName: "Rundbaken", honorific: "Dr." },
    npi: "1720072903",
    ehrId: "11",
  },
  VALENZUELA: {
    displayName: "S. Valenzuela",
    name: { givenName: "Shannon", familyName: "Valenzuela", honorific: "Dr." },
    npi: "1134118995",
    ehrId: "10",
  },
  ANDERSON: {
    displayName: "M. Anderson",
    name: { givenName: "Melanie", familyName: "Anderson" },
    npi: "1770397259",
    ehrId: "12",
  },
  GROSS: {
    displayName: "K. Gross",
    name: { givenName: "Katherine", familyName: "Gross", honorific: "Dr." },
    npi: "1336584184",
    ehrId: "37",
  },
  DENENBERG: {
    displayName: "M. Denenberg",
    name: { givenName: "Michael", familyName: "Denenberg", honorific: "Dr." },
    npi: "1538173794",
    ehrId: "1",
  },
  SENA: { displayName: "M. Sena", name: { givenName: "Marie", familyName: "Sena" }, npi: "1285265298", ehrId: "71" },
} as const satisfies Record<string, IdentifiedProviderDefinition>;
